<template>
  <!-- register-entity -->
    <div class="  d-flex flex-column align-items-center">
      <div class='main-content'>
        <el-steps :active="step" align-center finish-status="success" class="d-flex justify-content-center">
          <el-step title="Entity Details"></el-step>
          <el-step v-show="hasAdditionalQs > 0" title="Additional Questions"></el-step>
          <el-step v-show="hasSaleableItems > 0" title="Store"></el-step>
          <el-step title="Summary & Payment"></el-step>
        </el-steps>
        <content-body-card>
          <entity-details v-if="step === 0" :value="registration"  :membership="selectedMembership" @update-step="updateStep" @tc-update="updateButtonStatus" ref="rego"/>
          <additional-questions v-if="step === 1" :value="registration" @update-step="updateStep" ref="rego"/>
          <store v-if="step === 2" :value="registration" @update-step="updateStep" ref="rego" @update-store="updateButtonStatus"/>
          <payment v-if="step === 3" :value="registration" @update-step="updateStep" :membership="selectedMembership" ref="rego"/>
          <el-row class="mt-10">
            <el-divider></el-divider>
            <el-row :span="24" class="d-flex mt-10" :gutter="20">
              <el-col :span="12" class="d-flex justify-content-end">
                <el-button class="bottomBtn respBtn" @click="back">Back</el-button>
              </el-col>
              <el-col :span="12">
                <el-button type="primary" :class="isNextDisabled ? 'bottomBtn disabled-next' : 'btn-highlight bottomBtn'" @click.prevent="next">
                  Next
                </el-button>
              </el-col>
            </el-row>
          </el-row>
        </content-body-card>
        <!-- <div class="payment-card" v-else>
          <payment v-if="step === 3" :value="registration" @update-step="updateStep" ref="rego"/>
          <el-row class="mt-10 mx-10">
            <el-divider></el-divider>
            <el-row :span="24" class="d-flex mt-10" :gutter="20">
              <el-col :span="12" class="d-flex justify-content-end">
                <el-button class="bottomBtn" @click="back">Back</el-button>
              </el-col>
              <el-col :span="12">
                <el-button type="primary" class="btn-highlight bottomBtn" @click.prevent="next">
                  {{ step === 3 ? 'Pay & Complete' : 'Next' }}
                </el-button>
              </el-col>
            </el-row>
          </el-row>
        </div> -->
      </div>
    </div>
  </template>

<script>
import _ from 'lodash';
import EntityDetails from './1-EntityDetails.vue';
import AdditionalQuestions from './2-AdditionalQuestions.vue';
import Store from './3-Store.vue';
import Payment from './4-Payment.vue';

export default {
  name: 'RegisterTeam',
  components: {
    EntityDetails,
    AdditionalQuestions,
    Store,
    Payment
  },
  props: {
    criteria: String,
    selectedMembership: Object
  },
  data() {
    return {
      step: 0,
      registration: {
        membershipId: undefined,
        productType: undefined,
        tags: undefined,
        entity: undefined,
        product: undefined,
        additionalQs: undefined,
        saleableItems: undefined,
        discounts: undefined,
        meta: undefined
      },
      isNextDisabled: true
    };
  },
  mounted() {
    const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
    if (!this.selectedMembership) this.$router.push({ name: pathName });
  },
  methods: {
    updateButtonStatus(status) {
      this.isNextDisabled = status;
    },
    updateStep(val, step = 1) {
      _.assign(this.registration, val);

      if (step > 0) {
        if (step !== 3) this.step += step;
        if (this.step === 1 && !this.hasAdditionalQs) this.step += 1;
        if (this.step === 2 && !this.hasSaleableItems) this.step += 1;
      }
      if (step < 0) {
        if (step !== 3) this.step += step;
        if ((this.step === 2) && !this.hasSaleableItems) this.step -= 1;
        if (this.step === 1 && !this.hasAdditionalQs) this.step -= 1;
      }
      this.isNextDisabled = false;
    },
    cancel() {
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      this.$router.push({ name: pathName, params: { defaultCriteria: this.criteria } });
    },
    back() {
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      if (this.step === 0) this.$router.push({ name: pathName, params: { defaultCriteria: this.criteria } });
      else this.$refs.rego.updateStep(-1);
    },
    next() {
      this.$refs.rego.updateStep(1);
    }
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    hasAdditionalQs() {
      return this.registration.additionalQs && this.registration.additionalQs.length;
    },
    hasSaleableItems() {
      return this.registration.saleableItems && this.registration.saleableItems.length;
    }
  }
};
</script>

  <style scoped lang="scss">
  .main-content {
    width: 90%;
    max-width: $md;

    // .content-body {
    //   width: 100%;
    // }
    // .payment-card {
    //   border: 1
    // }

    .bottomBtn {
      max-width: 100%;
      width: 12em;
    }

    @media screen and (device-aspect-ratio: 40/71) {
      .bottomBtn {
        font-size: 0.8em;
      }
      .respBtn {
        font-size: 0.75em !important;
      }
    }

    .disabled-next {
      background: var(--highlight-color);
      opacity: 0.7;
      border: 0 !important;
      cursor: pointer !important;
    }
  }
  </style>
